import { type OrderStatusFilterName } from '@hungryroot/segment';

export enum OrdersTab {
  Cart = 'cart',
  OnTheWay = 'on-the-way',
  Upcoming = 'upcoming',
  Delivered = 'delivered',
}

export const ORDERS_TAB_PARAM = 'tab';

/** Canonical left-to-right tab order; also the order swipe navigation follows. */
export const ALL_TABS: ReadonlyArray<OrdersTab> = [
  OrdersTab.Cart,
  OrdersTab.OnTheWay,
  OrdersTab.Upcoming,
  OrdersTab.Delivered,
];

export function parseTabFromSearch(search: string): OrdersTab {
  const params = new URLSearchParams(search);
  const raw = params.get(ORDERS_TAB_PARAM);
  const match = ALL_TABS.find((tab) => tab === raw);
  return match ?? OrdersTab.Cart;
}

/**
 * Maps each Orders sub-tab to its `order_status_filter` analytics value
 * (snake_case). Note `OrdersTab.OnTheWay` (`'on-the-way'`) normalizes to
 * `'on_the_way'`.
 */
export const ORDER_STATUS_FILTER_NAME: Record<
  OrdersTab,
  OrderStatusFilterName
> = {
  [OrdersTab.Cart]: 'in_your_cart',
  [OrdersTab.OnTheWay]: 'on_the_way',
  [OrdersTab.Upcoming]: 'upcoming',
  [OrdersTab.Delivered]: 'delivered',
};
